var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ChromePicker',{attrs:{"value":_vm.color},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }